export default __webpack_public_path__ + "static/media/raodmap_rocket.01b3dda8.png";